import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import '../../../../src/Components/css/Designprocess.css'

export default class Dev extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
                <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ux_design">
                    <div className="col-12 px-0" id="ow">
                      <p className="h4">Overview</p>
                      <p className="pt-1">
                      Dev is a coding based e-learning website. Coding is important because computers are unable to interact with our native languages. They can only understand machine code which is in binary or hexadecimal. It is a coder's job to enable humans and machines to be able to "talk" to each other. So we going to create a Dev website it will help Coders to learn new computer language fastly and easily with a help of personal mentors.
                      </p>
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <div className="row mx-0" id="po">
                        <div className="col-sm-4 text-center">
                          <p className="h5">Business type</p>
                          <p>B2C</p>
                        </div>
                        <div className="col-sm-4 text-center">
                          <p className="h5">Project duration</p>
                          <p>2 months</p>
                        </div>
                        <div className="col-sm-4 text-center">
                          <p className="h5">My role</p>
                          <p>Ux Designer</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <p className="h4">Problem Statement</p>
                        <p className="pt-1">
                        <span className="bullet">Students Can't understand the coding through books and videos<br></br></span>
                        <span className="bullet">Teachers wanna share their knowledge apart from college<br></br></span>
                        <span className="bullet">Students need a source code for their project<br></br></span>
                        <span className="bullet">Teachers need a source code to explain their student as much as simple</span>
                        </p>
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <p className="h4">Project Goal</p>
                        <p className="pt-1">
                        <span className="bullet">In this website students can choose their mentors<br></br></span>
                        <span className="bullet">Teacher can share their knowledge via videos, images, snippets, and screencasts<br></br></span>
                        <span className="bullet">Copy to clipboard option and save to collection features</span>
                        </p>
                    </div>
                    <div className="col-12 px-0 pt-4" id="ds">
                    <p className="h4">Design Process</p>
                      <div className="process">
                      <div>DISCOVER</div>
                      <div>DEFINE</div>
                      <div>IDEATE</div>
                      <div>DESIGN</div>
                      <div>TEST</div>
                      </div>
                    </div>
  
                </div>

                <div className="row pt-4" id="ui_design">
                    <div className="col-12 px-0">
                      <img width="100%" id="sn" src={require('../../../Images/Case_studies/Dev/Survey_question.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="sa" src={require('../../../Images/Case_studies/Dev/Survey_data.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="ua" src={require('../../../Images/Case_studies/Dev/User_persona.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="ep" src={require('../../../Images/Case_studies/Dev/Empathy_map.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="sd" src={require('../../../Images/Case_studies/Dev/Story_board.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="cg" src={require('../../../Images/Case_studies/Dev/Card_sorting.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="uw" src={require('../../../Images/Case_studies/Dev/User_flow.png')} alt="Case_studies_1" />
                    </div>
                </div>
                
                <div className="row pt-4" id="development">
            
                </div>

            </div>
                    
            <div className="col-lg-2 d-none d-lg-block px-4 pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

              <p className="h4">CONTENT</p>
                <p>
                  <AnchorLink href="#ow" className="bullet">Overview</AnchorLink>
                  <br />
                  <AnchorLink href="#po" className="bullet">Project info</AnchorLink>
                  <br />
                  <AnchorLink href="#ds" className="bullet">Design process</AnchorLink>
                  <br />
                  <AnchorLink href="#sn" className="bullet">Survay question</AnchorLink>
                  <br />
                  <AnchorLink href="#sa" className="bullet">Survay data</AnchorLink>
                  <br />
                  <AnchorLink href="#ua" className="bullet">User persona</AnchorLink>
                  <br />
                  <AnchorLink href="#ep" className="bullet">Empathy map</AnchorLink>
                  <br />
                  <AnchorLink href="#sd" className="bullet">Story board</AnchorLink>
                  <br />
                  <AnchorLink href="#cg" className="bullet">Card sorting</AnchorLink>
                  <br />
                  <AnchorLink href="#uw" className="bullet">User flow</AnchorLink>
                  <p className="text-danger">Under process</p>
                </p>

                <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                  <div className="col-12 px-2">
                    <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/xd.png')} alt="Case_studies_1" />
                          <img width="25%" className="tools" src={require('../../../Images/Tools/ps.png')} alt="Case_studies_1" />
                    </div>
                  </div>
                
                </div>

                </div>
                
                  
            </div>
    )
}
}